export const Five = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(2 2)">
      <path
      d="M20.7448 12.0312H14.9115L14.3281 17.5312L15.6756 16.9533C16.324 16.6755 17.0391 16.531 17.764 16.5312H17.8281C18.7564 16.5312 19.6466 16.8473 20.303 17.4099C20.9594 17.9725 21.3281 18.7356 21.3281 19.5312V21.0312C21.3281 21.8269 20.9594 22.59 20.303 23.1526C19.6466 23.7152 18.7564 24.0313 17.8281 24.0313C16.3045 24.0313 14.8088 23.1963 14.3281 22.0313"
      stroke="#3D3D3D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.75 17.75C0.75 22.2587 2.54107 26.5827 5.72918 29.7708C8.9173 32.9589 13.2413 34.75 17.75 34.75C22.2587 34.75 26.5827 32.9589 29.7708 29.7708C32.9589 26.5827 34.75 22.2587 34.75 17.75C34.75 13.2413 32.9589 8.9173 29.7708 5.72918C26.5827 2.54107 22.2587 0.75 17.75 0.75C13.2413 0.75 8.9173 2.54107 5.72918 5.72918C2.54107 8.9173 0.75 13.2413 0.75 17.75Z"
      stroke="#F0F4F7"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    </g>
  </svg>
)
